import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import {
  GeneralFieldsFormData,
  HolderSectionFormData,
  PrimaryBankDetailsFormData,
  SecondaryBankDetailsFormData,
  TechnicalDirectorFormData,
  TechnicalManagerFormData,
} from '../formTypes'
import { SponsorUpdateApiError } from '../validation'

type Props = {
  error: Maybe<SponsorUpdateApiError>
}

export const UserRegistrationErrorHandler = ({ error }: Props): JSX.Element => {
  const { setError } = useFormContext()

  useEffect(() => {
    if (!error) return

    const setErrorMessage = (
      key: string,
      errors: string | string[] | undefined
    ) => {
      const flattedMessage = [...(errors || [])]
        .map((error) =>
          error[0] ? error[0].toUpperCase() + error.slice(1) : ''
        )
        .join('\n')

      setError(key, {
        type: 'server_error', // Just to identify an error from server validation, has no function at the moment, may be needed in future if mixed validation is implemented
        message: flattedMessage,
      })
    }

    // Errors for general fields
    if (error.sponsorman) {
      Object.keys(error.sponsorman).forEach((key: unknown) => {
        const sponsorKey = key as keyof GeneralFieldsFormData
        const errorMessage =
          error && error.sponsorman && error.sponsorman[sponsorKey]
        setErrorMessage(sponsorKey, errorMessage)
      })
    }

    // Errors for holder
    if (error.holder_address) {
      Object.keys(error.holder_address).forEach((key: unknown) => {
        const holderKey = key as keyof HolderSectionFormData

        const errorMessage =
          error && error.holder_address && error.holder_address[holderKey]
        setErrorMessage(`holder_address.${holderKey}`, errorMessage)
      })
    }

    // Errors for technical director
    if (error.technical_director_address) {
      Object.keys(error.technical_director_address).forEach((key: unknown) => {
        const holderKey = key as keyof TechnicalDirectorFormData
        const errorMessage =
          error &&
          error.technical_director_address &&
          error.technical_director_address[holderKey]

        setErrorMessage(`technical_director_address.${holderKey}`, errorMessage)
      })
    }

    // Errors for technical manager
    if (error.technical_manager_address) {
      Object.keys(error.technical_manager_address).forEach((key: unknown) => {
        const holderKey = key as keyof TechnicalManagerFormData
        const errorMessage =
          error &&
          error.technical_manager_address &&
          error.technical_manager_address[holderKey]

        setErrorMessage(`technical_manager_address.${holderKey}`, errorMessage)
      })
    }

    // Errors for bank account 1
    if (error.bank_account_1) {
      Object.keys(error.bank_account_1).forEach((key: unknown) => {
        const bankKey = key as keyof PrimaryBankDetailsFormData
        const errorMessage =
          error && error.bank_account_1 && error.bank_account_1[bankKey]

        setErrorMessage(`bank_account_1.${bankKey}`, errorMessage)
      })
    }

    // Errors for bank account 2
    if (error.bank_account_2) {
      Object.keys(error.bank_account_2).forEach((key: unknown) => {
        const bankKey = key as keyof SecondaryBankDetailsFormData
        const errorMessage =
          error && error.bank_account_2 && error.bank_account_2[bankKey]

        setErrorMessage(`bank_account_2.${bankKey}`, errorMessage)
      })
    }
  }, [error, setError])

  return <></>
}
